export const localize = {
  table_show: "Hiển thị",
  table_empty: "Không có dữ liệu",
  table_loading: "Đang tải... Vui lòng chờ",
};
